<template>
	<div class="ew-file-uploader">
		<div class="label">{{ label }}</div>
		<div class="upload-button" @click="onClickUploadButton">{{ buttonText }}</div>
		<input type="file" ref="file" class="file-input" @change="onFileChange" :accept="accept" :multiple="multiple" />
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			default: 'Picture',
		},
		accept: {
			type: String,
			default: 'image/*',
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		buttonText: {
			type: String,
			default: 'Choose a file from your computer',
		},
		files: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	methods: {
		onClickUploadButton() {
			this.$refs.file.click();
		},
		onFileChange(e) {
			if (e.target.files && e.target.files.length > 0) {
				this.$emit('change', e.target.files);
			} else {
				this.$emit('change', []);
			}
		},
	},
	mounted() {
		if (this.files && this.files.length > 0) {
			this.$ref.files = this.files;
		}
	},
};
</script>

<style lang="scss">
.ew-file-uploader {
	display: flex;
	justify-content: space-between;
	align-items: center;
    font-size: 0.75rem;

	.label {
		margin-right: 20px;
		padding: 0 10px;
	}

	.upload-button {
		text-transform: uppercase;
		background-color: #b9b9b9;
		color: #fff;
		padding: 15px;
		cursor: pointer;

		&:hover {
			background-color: var(--primary-color);
		}
	}

	.file-input {
		display: none;
	}
}
</style>
